import React, { useState, useEffect } from 'react';
import { Row, Col, Card, HeadingText, Tooltip, BodyText, Link, Button, Checkbox, CaptionText, PAYPAL_THEME } from '@paypalcorp/pp-react';
import { GetStartProfile } from './GetStartProfile';
import { Profile } from './Profile';
import { get } from 'lodash';
import { parseMessages } from '../../utilityHelper';
import * as FPT from '../../utility/fpt';
import ExtendSession from '../../ppgf/components/ExtendSession';
import withTheme from '../../common/withTheme';
const { sysColorOverlayMain } = PAYPAL_THEME;

const messages = parseMessages('givingfund').profile;
const ProfileTab = (props) => {
    const pageDetails = JSON.parse(document.getElementById('data-page-details') && document.getElementById('data-page-details').innerHTML || '{}');
    const showProfile = (props.charityInfo.description || props.charityInfo.slogan || props.charityInfo.missionArea || props.charityInfo.keywords || props.charityInfo.logo_url);
    const [news, setNews] = useState({ value: props.charityInfo.news_letter_flag });
    const [listing, setListing] = useState({ value: props.charityInfo.ebay_listing_flag });
    const version = pageDetails.getStartProfileTMT ? 'v2' : 'v1';
    const handleClick = async (value, payload, setValue) => {
        FPT.trackButtonClickWithData('emailPreferences', payload);
        let success = await props.onSubmitProfileForm(payload);
        setValue({ value: success && value, error: !success, errorText: messages.serviceError });
    }

    return (
        <>
            <ExtendSession scaCountry={pageDetails.scaCountry} basePage={showProfile ? 'viewProfile' : 'getStarted'} />
            <Row>
                {!pageDetails.directModel && !props.manualEnroll && <Col xs={12} xxl={4} style={{ paddingRight: '3rem' }}>
                    <Card >
                        <HeadingText id="paypalAccount" size="sm">{messages.account.head}<Tooltip screenReaderText={messages.account.head} name="paypalAccount" description={messages.account.help} /></HeadingText>
                        <BodyText style={{ textOverflow: 'ellipsis', overflow: 'hidden', margin: '0.75rem 0 0.5rem 0', whiteSpace: 'nowrap' }}>{props.charityInfo.email_address}</BodyText>
                        <Link target="_blank" href="/" data-fpti="paypalAccountLink" size="sm">{messages.account.link}</Link>
                        <CaptionText style={{ margin: '1.5rem 0', color: sysColorOverlayMain }} strong>{messages.preferences.head}</CaptionText>
                        <div style={{ marginBottom: '2.25rem' }}><Checkbox label={messages.preferences.news} name="news" errorText={news.errorText} error={news.error} checked={news.value} onChange={() => handleClick(!news.value, { news_letter_flag: !news.value }, setNews)} /></div>
                        <div><Checkbox label={messages.preferences.listing} name="listing" errorText={listing.errorText} error={listing.error} checked={listing.value} onChange={() => handleClick(!listing.value, { ebay_listing_flag: !listing.value }, setListing)} /></div>
                    </Card>
                    <Card style={{ margin: '1.5rem 0' }}>
                        <HeadingText size="sm" style={{ marginBottom: '0.75rem' }}>{messages.contact.head}</HeadingText>
                        {props.charityInfo.secondaryContact ? <SecondaryContact charityInfo={props.charityInfo} setProfileEditView={props.setProfileEditView} /> :
                            (<div style={{ display: 'flex', justifyContent: 'center', margin: '1.125rem 0 0.625rem 0' }}>
                                <Button onClick={() => props.setProfileEditView('contact', 'editContactBtn')} secondary>{messages.contact.button}</Button>
                            </div>)}
                    </Card>
                </Col>
                }
                <Col>
                    {
                        showProfile ? <Profile {...props} /> : <GetStartProfile version={props.manualEnroll ? 'manual' : version} setProfileEditView={props.setProfileEditView} />
                    }
                </Col>
            </Row>
        </>
    );
}

const SecondaryContact = (props) => {
    return (
        <Row>
            <Col xs={12} xxl={9}>
                <BodyText>{get(props.charityInfo, 'secondaryContact.contactName', '')}</BodyText>
                <BodyText>{get(props.charityInfo, 'secondaryContact.job_title', '')}</BodyText>
                <BodyText>{get(props.charityInfo, 'secondaryContact.formattedPhone', '')}</BodyText>
                <BodyText>{get(props.charityInfo, 'secondaryContact.email_address', '')}</BodyText>
            </Col>
            <Col xs={12} xxl={3}>
                <Link size="sm" onClick={() => props.setProfileEditView('contact', 'editContactBtn')}>{messages.edit}</Link>
            </Col>
        </Row>
    )
};
``
export default withTheme(ProfileTab);